import React                        from 'react';
import { Observe, version }         from 'rewire-core';
import { DraggableResizableDialog } from 'rewire-ui';
import { Theme, makeStyles }        from '../utility/styles';
import { FormFields }               from './DefaultEditFormView';
import { If, useWatch }             from './SettingsModel';
import Grid                         from '../ui/Grid';
import Tabs                         from '@material-ui/core/Tabs';
import Tab                          from '@material-ui/core/Tab';
import FormButtons                  from './FormButtons';
import  timecardExportConfigDialogModel, {
  ExportOutputFieldEditorModel,
  TimecardExportConfigModel,
  TimecardExportSettingsModel
}                                   from './TimecardExportOutputEditorModel';

const exportOutputFieldStyle = (theme: Theme) => ({
  root: {
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    '& .unindent': {
      marginTop: 8,
      marginLeft: '-8px',
      fontSize: '18px'
    },
    '& .detail.selected': {
      backgroundColor: '#e5ecf2'
    },
    '& .detail': {
      borderTop: '2px solid #b2b2b2',
      backgroundColor: '#fafaea'
    },
  },
  tabs: {
    flex: '1 1 0',
    display: 'flex',
    flexDirection: 'column'
  },
  bottom: {
    display: 'flex',
    height: '100%',
    flex: '3',
    flexDirection: 'column'
  },
  middle: {
    display: 'flex',
    height: '100%',
    flex: '1',
    flexDirection: 'column'
  },
  top: {
    display: 'flex',
    flex: '0 0 auto'
  },
  left: {
    flex: '0 0 250px',
    margin: 8,
    border: `1px solid ${theme.palette.grey['300']}`,
    overflowY: 'auto'
  },
  title: {
    display: 'flex',
    alignSelf: 'stretch',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& h6': {flex: 1}
  },
  heading: {
    display: 'flex',
    flexShrink: 0,
    alignItems: 'center',
    flexDirection: 'column',
    margin: '8px 8px 0px 8px',
    padding: '0px 5px 0px 5px',
    '& > h6': {
      width: '100%',
    },
    '& > hr': {
      marginTop: '8px',
      marginBottom: '0px',
      width: '100%',
      border: '1px solid #eee'
    },
  },
  actionsContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  childrenContainer: {
    paddingTop: '0px',
    paddingBottom: '0px',
  },
  right: {
    flex: '0 0 auto',
    minWidth: '250px',
    flexDirection: 'row',
    display: 'flex'
  },
  formButtonsRoot: {
    display: 'flex !important',
    flex: '1',
    justifyContent: 'flex-end',
  },
  formButtonsButton: {
    minWidth: '90px',
    margin: '0px 16px',
    minHeight: '36px'
  },
});

const useExportOutputFieldStyle = makeStyles(exportOutputFieldStyle);
const renderTitleFn = () => (): JSX.Element => {
  const classes = useExportOutputFieldStyle();
  return (
      <div className={classes.title}>
        <div>Define Output File Layout</div>
        <div className={classes.actionsContainer}>
          {/* <UdfAddMenu udfsModel={timecardExportConfigModel} /> */}
        </div>
      </div>
  );
};

const ExportFileView = (props: {model: TimecardExportConfigModel}) => {
  const editor = props.model.editor as ExportOutputFieldEditorModel;
  if (!editor) return null;
  // const form   = editor.form;
  // useWatch(() => form?.field['displayName']?.value, () => {
  //   requestAnimationFrame(() => editor.displayNameUpdated());
  // });

  // useWatch(() => form?.field['sourceField']?.value, () => {
  //   requestAnimationFrame(() => editor.sourceFieldUpdated());
  // });

  useWatch(() => version(props.model.headerDefinition.selectedCells), () => {
    requestAnimationFrame(() => props.model.selectCell());
  });

  const classes = useExportOutputFieldStyle();
  return (
    <Observe render={() => (
      <div className={classes.root}>
        <div className={classes.top}>
          <FormFields form={props.model.headerForm} />
        </div>
        <div className={classes.middle}>
          <Grid grid={props.model.headerDefinition} />
        </div>
        <hr style={{margin: '0 10px'}} />
        <div className={classes.bottom}>
          <If condition={editor.visible} then={<FormFields form={editor.form} />} />
        </div>
      </div>
    )} />
  );
};

const ExportSettingsView = (props: {model: TimecardExportSettingsModel}) => {
  const classes = useExportOutputFieldStyle();
  return (
    <Observe render={() => (
      <div className={classes.root}>
        <div className={classes.bottom}>
          <FormFields form={props.model.rollupForm} />
        </div>
      </div>
    )} />
  );
};

const ExportTabs = () => {
  const classes = useExportOutputFieldStyle();
  const [value, setValue] = React.useState(0);

  const handleChange = (_event: unknown, newValue: number) => {
    setValue(newValue);
  };

  return (
  <div className={classes.tabs}>
    <Tabs indicatorColor='primary' textColor='primary' value={value} onChange={handleChange}>
      <Tab label='File' />
      <Tab label='Report'/>
      <Tab label='Settings' />
    </Tabs>
    <If condition={value === 0} then={<ExportFileView model={timecardExportConfigDialogModel.fileExportConfigModel}/>} />
    <If condition={value === 1} then={<ExportFileView model={timecardExportConfigDialogModel.reportExportConfigModel}/>} />
    <If condition={value === 2} then={<ExportSettingsView model={timecardExportConfigDialogModel.settingsExportConfigModel}/>} />
    <FormButtons modal={timecardExportConfigDialogModel} actions={['save', 'close']} classes={{root: classes.formButtonsRoot, button: classes.formButtonsButton}} />
  </div>);
};

const ExportConfigDialogView = () => {
  const classes = useExportOutputFieldStyle();
  return (
    <DraggableResizableDialog
    defaultWidth='lg'
    classes={{heading: classes.heading, childrenContainer: classes.childrenContainer }}
    DialogProps={{dialog: timecardExportConfigDialogModel, title: renderTitleFn(), actions: []}}
    DraggableResizableBoxProps={{minWidth: '80vw', minHeight: '95vh'}}
    >
      <ExportTabs />
    </DraggableResizableDialog>
  );
};

export default () => <Observe>{() => <If condition={timecardExportConfigDialogModel.visible} then={ExportConfigDialogView} else={null} />}</Observe>;
